import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface AudioVisualizerProps {
  isPlaying: boolean;
}
export function AudioVisualizer({
  isPlaying
}: AudioVisualizerProps) {
  // Simulate frequency data
  const [frequencies, setFrequencies] = useState<number[]>(Array(16).fill(0));
  useEffect(() => {
    if (!isPlaying) {
      setFrequencies(Array(16).fill(0));
      return;
    }
    const interval = setInterval(() => {
      // Generate random "frequency" data for visualization
      const newFreqs = Array(16).fill(0).map(() => Math.random());
      setFrequencies(newFreqs);
    }, 150); // Jazz tempo approx
    return () => clearInterval(interval);
  }, [isPlaying]);
  return <div className="w-full h-full bg-mondrian-black p-2 grid grid-cols-4 gap-2" data-id="element-23">
      {frequencies.map((freq, i) => {
      // Map frequency to color
      let bgClass = 'bg-mondrian-white';
      if (freq > 0.8) bgClass = 'bg-mondrian-red'; // High energy / drum
      else if (freq > 0.5) bgClass = 'bg-mondrian-yellow'; // Melody
      else if (freq > 0.3) bgClass = 'bg-mondrian-blue'; // Bass
      else bgClass = 'bg-mondrian-gray'; // Quiet
      return <motion.div key={i} className={`w-full h-full ${bgClass} border-2 border-mondrian-black`} animate={{
        scale: isPlaying ? 0.9 + freq * 0.2 : 1,
        opacity: isPlaying ? 0.8 + freq * 0.2 : 1
      }} transition={{
        duration: 0.1
      }} data-id="element-24" />;
    })}
    </div>;
}